import {
  formatIsoDate,
  formatName,
  renderStatus,
} from "../../../utils/generalUtils";

import GeneratePdf from "../../../generatePdf/GeneratePdf";
import { Space } from "antd";

import ViewingFormButton from "../../Form/ViewingFormButton";
// import ConfirmDelete from "../../ConfirmDelete/ConfirmDelete";

export const cosConfig = {
  docType: "Certificate of Service",
  title: "Certificate of Service",
  description:
    "Submit certificate of service. Your request will be reviewed by your assigned approver. Once approved, you may download the official document.",
  apiConfig: {
    get: "/employee/cos",
    post: "/employee/addcos",
  },
  dataMapper: (item, index) => ({
    ...item,
    name: `${item?.submission?.submitter?.last_name || ""}, ${
      item?.submission?.submitter?.first_name || ""
    }`.trim(),
    formattedName: formatName(
      item?.submission?.submitter?.first_name,
      item?.submission?.submitter?.middle_name,
      item?.submission?.submitter?.last_name,
      "lfmcut"
    ),
    approver_name: `${item?.submission?.approval?.approver?.last_name || ""} ${
      item?.submission?.approval?.approver?.first_name || ""
    }`.trim(),
    formattedApproverName: formatName(
      item?.submission?.approval?.approver?.first_name,
      item?.submission?.approval?.approver?.middle_name,
      item?.submission?.approval?.approver?.last_name,
      "lfmcut"
    ),
    submitter_position: item?.submission?.position?.position_name,
    submitter_position_unit: item?.submission?.position?.unit,
    approval_date: item?.submission?.approval?.approval_date,
    remarks: item?.submission?.remarks,
    date_submitted: item?.created_at ? formatIsoDate(item?.created_at) : null,
    key: index + 1,
    status: item?.submission?.status,
  }),
  viewingDataConfig: [
    {
      key: 1,
      collapseName: "Required Details",
      collapseItems: [
        {
          key: 1,
          name: "submitter_position",
          label: "Position",
        },
        {
          key: 2,
          name: "start_date",
          label: "Start Date",
        },
        {
          key: 3,
          name: "end_date",
          label: "End Date",
        },
        {
          key: 4,
          name: "absent",
          label: "Leave of Absence",
        },
      ],
    },
    {
      key: 2,
      collapseName: "Additional Details",
      collapseItems: [
        {
          key: 1,
          name: "act1",
          label: "Activity 1",
        },
        {
          key: 2,
          name: "week1_hours",
          label: "No. of hours per week 1",
        },
        {
          key: 3,
          name: "act2",
          label: "Activity 2",
        },
        {
          key: 4,
          name: "week2_hours",
          label: "No. of hours per week 2",
        },
        {
          key: 5,
          name: "act3",
          label: "Activity 3",
        },
        {
          key: 6,
          name: "week3_hours",
          label: "No. of hours per week 3",
        },
        {
          key: 7,
          name: "act4",
          label: "Activity 4",
        },
        {
          key: 8,
          name: "week4_hours",
          label: "No. of hours per week 4",
        },
        {
          key: 9,
          name: "act5",
          label: "Activity 5",
        },
        {
          key: 10,
          name: "week5_hours",
          label: "No. of hours per week 5",
        },
      ],
    },
  ],
  columns: (onDeleted) => [
    { title: "No.", dataIndex: "key", rowScope: "row", width: 60 },
    {
      title: "Position",
      dataIndex: "submitter_position",
      key: "submitter_position",
    },
    { title: "Start Date", dataIndex: "start_date", key: "start_date" },
    { title: "End Date", dataIndex: "end_date", key: "end_date" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending"],
        ["approved"],
        ["disapproved", "denied"]
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, item) => (
        <Space>
          <GeneratePdf
            docuType="cos"
            contents={item}
            isEmployee={true}
            isIcon={true}
            disabled={item?.status !== "approved"}
          />
          <ViewingFormButton
            contents={item}
            viewingDataConfig={cosConfig.viewingDataConfig}
            isIcon={true}
          />
          {/* <ConfirmDelete
            isIcon={true}
            rowId={item?.id}
            buttonText="Delete Submission"
            docType="cos"
            onDeleted={onDeleted}
          /> */}
        </Space>
      ),
    },
    {
      title: "Date Submitted",
      dataIndex: "date_submitted",
      key: "date_submitted",
    },
  ],
  formFields: [
    {
      name: "date",
      label: "Date",
      type: "daterange",
      onSameMonth: true,
      rules: [{ required: true, message: "This is required" }],
    },
    {
      name: "absent",
      label: "Date of Absences",
      // rules: [{ required: true }],
      extra:
        "Format: 'March 1, 2025, March 3, 2025' or 'March 1, 2025 to March 15, 2025'",
      type: "radiotextbox",
    },
    {
      name: "act1",
      label: "Activity 1",
      placeholder: "Enter Activity 1",
    },
    {
      name: "week1_hours",
      label: "No. of hours per week 1",
    },
    {
      name: "act2",
      label: "Activity 2",
      placeholder: "Enter Activity 2",
    },
    {
      name: "week2_hours",
      label: "No. of hours per week 2",
    },
    {
      name: "act3",
      label: "Activity 3",
      placeholder: "Enter Activity 3",
    },
    {
      name: "week3_hours",
      label: "No. of hours per week 3",
    },
    {
      name: "act4",
      label: "Activity 4",
      placeholder: "Enter Activity 4",
    },
    {
      name: "week4_hours",
      label: "No. of hours per week 4",
    },
    {
      name: "act5",
      label: "Activity 5",
      placeholder: "Enter Activity 5",
    },
    {
      name: "week5_hours",
      label: "No. of hours per week 5",
    },
  ],
};
